import React from "react";
import "./CustomLoader.css";

const CustomLoader = ({ text = "Loading" }) => {
  return (
    <div className="loader-wrapper">
      <div className="loader-body">
        <span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </span>
        <div className="loader-base">
          <span>
            <div className="loader-face"></div>
          </span>
        </div>
      </div>
      <div className="loader-longfazers">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <h1 className="loader-text">{text}</h1>
    </div>
  );
};

export default CustomLoader;
